import { ConcreteEncodable } from "./ConcreteEncodable";

import { LinkedOrderInfoModificationRequestImplEncoder } from "../../encoder/LinkedOrderInfoModificationRequestImplEncoder";

import * as CubiqTS from "../../index";
import { LinkedOrderInfoModificationRequest } from "../LinkedOrderInfoModificationRequest";

export class LinkedOrderInfoModificationRequestImpl
  extends ConcreteEncodable
  implements LinkedOrderInfoModificationRequest
{
  public static enType: string = "com.bcdfx.model.event.LinkedOrderInfoModificationRequestImpl";

  /*FID=1*/
  public orderUpdates: Array<CubiqTS.OrderUpdate> | null = null;
  /*FID=2*/
  public clientTrader: string;
  /*FID=3*/
  public isContactsEnabled: boolean;
  /*FID=4*/
  public changeMask: CubiqTS.Long | null = null;
  /*FID=5*/
  public orderId: string;
  /*FID=6*/
  public clientContactIds: Array<CubiqTS.Long> | null = null;
  /*FID=7*/
  public oboUser: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = LinkedOrderInfoModificationRequestImplEncoder.Instance;
    this.setEncodableType(LinkedOrderInfoModificationRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "LinkedOrderInfoModificationRequestImpl[" +
      "orderUpdates=" +
      this.orderUpdates +
      "clientTrader=" +
      this.clientTrader +
      "isContactsEnabled=" +
      this.isContactsEnabled +
      "changeMask=" +
      this.changeMask +
      "orderId=" +
      this.orderId +
      "clientContactIds=" +
      this.clientContactIds +
      "oboUser=" +
      this.oboUser +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
